import { gtmSendEvent } from "@wojo/analytics";
import { Button, Text } from "@wojo/ui";
import { InfoCard } from "../info-card";
import { PushToAppButton } from "../push-to-app";
import styles from "./AccountPushToAppCardCard.module.scss";
import { AccountPushToAppCardCopy } from "./types";

export const AccountPushToAppCard: React.FC<{
    content: AccountPushToAppCardCopy;
    tourCode?: string;
}> = ({ content, tourCode }) => {
    const lightIconName = content.textCardIconLight;
    const darkIconName = content.textCardIconDark;
    return (
        <InfoCard
            graphic={{
                lightModeSrc: lightIconName,
                darkModeSrc: darkIconName,
                size: {
                    height: 64,
                },
            }}
            heading={
                <Text.Heading
                    order="3"
                    tag="h2"
                    style={{
                        color: "var(--s-color-info-foreground)",
                        marginBottom: "var(--g-spacing-sm)",
                        marginTop: "var(--g-spacing-md)",
                    }}
                >
                    {content.textCardTitle}
                </Text.Heading>
            }
        >
            <Text.Body
                style={{
                    color: "var(--s-color-info-foreground)",
                    marginBottom: "var(--g-spacing-md)",
                }}
            >
                {content.textCardBody}
            </Text.Body>
            <div className={styles["button-holder"]}>
                {!!content.textCardButton && (
                    <PushToAppButton
                        variant="primary"
                        palette="info"
                        tourCode={tourCode}
                        pushToAppText={content.textCardButton}
                    />
                )}
                {content.textCardQuietButton &&
                    content.textCardQuietButtonLink && (
                        <Button
                            variant="quiet"
                            palette="info"
                            tag="a"
                            href={content.textCardQuietButtonLink}
                            onClick={() =>
                                gtmSendEvent({
                                    event: "track",
                                    ga4Tracking: {
                                        ga4_object: "APP_MESSAGING",
                                        ga4_action: "CLICKED",
                                        clickText:
                                            content.textCardQuietButton ?? "",
                                        destinationUrl:
                                            content.textCardQuietButtonLink ??
                                            "",
                                        tourCode: tourCode ?? "",
                                    },
                                })
                            }
                        >
                            {content.textCardQuietButton}
                        </Button>
                    )}
            </div>
        </InfoCard>
    );
};
